import { useNavigate } from '@tanstack/react-router';
import { LockKeyhole } from 'lucide-react';
import { useEffect } from 'react';

import { Card, CardContent } from '@/components/ui/card';
import { useI18n } from '@/lib/i18n';

interface AuthRequiredStateProps {
  message?: string;
}

export function AuthRequiredState({ message }: AuthRequiredStateProps) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const redirectTarget =
    typeof window !== 'undefined'
      ? `${window.location.pathname}${window.location.search}` || '/invoices'
      : '/invoices';

  useEffect(() => {
    void navigate({
      to: '/login',
      search: { redirect: redirectTarget },
      replace: true,
    });
  }, [navigate, redirectTarget]);

  return (
    <Card className="mx-auto max-w-xl">
      <CardContent className="flex flex-col items-center gap-4 py-16 text-center">
        <span
          aria-hidden
          className="grid size-12 place-items-center rounded-full bg-muted text-muted-foreground"
        >
          <LockKeyhole className="size-5" />
        </span>
        <div className="flex flex-col gap-2">
          <h2 className="text-lg font-semibold text-foreground">{t('auth.redirectTitle')}</h2>
          <p className="max-w-md text-sm text-muted-foreground">
            {message ?? t('auth.redirectMessage')}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
